import { render, staticRenderFns } from "./OrgEditMemberRolesModal.vue?vue&type=template&id=0684eb22"
import script from "./OrgEditMemberRolesModal.vue?vue&type=script&lang=js"
export * from "./OrgEditMemberRolesModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports